import { clamp } from 'lodash';
import { BREAKPOINTS } from '../../../utils/styles/breakpoints';
import { PRODUCT_PREVIEW_HEIGHT } from '../ProductsPreview/constants';
import { PostUI } from '../types';
import { POST_GRID_CARD_FOOTER_HEIGHT, POST_COLLECTION_GRID_CARD_RATIO } from './constants';
import { CalculateGridCardHeightOptions } from './types';

export const calculateGridCardHeight = (
    width: number,
    slides: PostUI['content'] = [],
    postType: PostUI['postType'],
    options?: CalculateGridCardHeightOptions,
) => {
    const { withoutFooter = false, withProductsPreview = false } = options ?? {};
    const [firstSlide] = slides;
    const [firstMedia] = firstSlide?.media ?? [];
    let ratio = clamp((firstMedia?.width || 1) / (firstMedia?.height || 1), 9 / 16, 16 / 9);

    if (postType === 'collection') {
        ratio = POST_COLLECTION_GRID_CARD_RATIO;
    }

    const height = width / ratio;
    const finalHeight =
        window.innerWidth < BREAKPOINTS.sm ? height : Math.min(height, window.innerHeight);

    const extraHeight =
        (withoutFooter ? 0 : POST_GRID_CARD_FOOTER_HEIGHT) +
        (withProductsPreview ? PRODUCT_PREVIEW_HEIGHT : 0);

    // Если ширина больше высоты, то делаем ее равной высоте, чтобы карточка была квадратной
    return Math.max(finalHeight, width) + extraHeight;
};
